export const functions = {
    methods: {
        _(val) {
            let _t = this;

            let page = 'App';

            if (_t.pageData && _t.pageData.page) {
                page = _t.pageData.page;
            }

            if (_t.$store.state.pages[page] && _t.$store.state.pages[page][val]) {
                return _t.$store.state.pages[page][val];
            }

            return '';
        },
        bgImgStyle: function(images, index, array){
            let stages = [];

            for (let i in images) {
                stages.push("url("+ images[i] +") " + i);
            }

            let str = "image-set(" + stages.join(',') + ")";

            let style = {
                "background-image": ['-webkit-' + str, str]
            };

            if (index != undefined && array) {
                style['z-index'] = array.length - index
            }

            return style;
        },
        randomInteger(min, max) {
          // получить случайное число от (min-0.5) до (max+0.5)
          let rand = min - 0.5 + Math.random() * (max - min + 1);
          return Math.round(rand);
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/functions.js